var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRaccoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.311 20.558",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "UnoptimicedTransforms"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 3.0065,
    d: "M3.768 9.669c3.78-2.534 7.387-5.173 7.387-5.173L27.74 10.3l11.56 9.261 10.59-5.43 13.05-.45 3.83 38.494-8.939-9.304-10.946 2.554-20.98 14.047-14.248-6.448 5.857-13.802L3.479 22.848Zm138.243 0c-3.78-2.534-7.386-5.173-7.386-5.173L118.04 10.3l-11.56 9.261-10.59-5.43-13.05-.45-3.83 38.494 8.939-9.304 10.945 2.554 20.98 14.047 14.248-6.448-5.856-13.802L142.3 22.848z",
    transform: "matrix(.18808 0 0 .2173 -.553 -.848)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 3.0065,
    d: "m17.545 38.585 12.611-12.61 9.327-6.534m88.751 19.144-12.61-12.61-9.327-6.534M26.373 59.695l15.198 16.293 25.57-12.77 3.883 11.231-6.104 7.082.302 7.504 4.324 2.296 2.101 5.044-5.423 1.56L42.95 85.939l-1.196-9.95m77.653-16.294-15.199 16.293-25.569-12.77-3.883 11.231 6.103 7.082-.302 7.504-4.323 2.296-2.101 5.044 5.423 1.56 23.274-11.996 1.196-9.95M47.98 50.534l1.464 6.11 11.853-.09-5.259-6.372zm49.82 0-1.464 6.11-11.854-.09 5.26-6.372z",
    transform: "matrix(.18808 0 0 .2173 -.553 -.848)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 3.0065,
    d: "m73.57 80.71-4.992-.222-.05 4.743 2.51 2.06 1.852.11m-.68-6.69 4.992-.223.05 4.743-2.51 2.06-1.852.11",
    transform: "matrix(.18808 0 0 .2173 -.553 -.848)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "white",
    strokeWidth: 3.0065,
    d: "M62.94 13.774h19.52M71.466 96.298h2.644",
    transform: "matrix(.18808 0 0 .2173 -.553 -.848)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaccoon);
export default __webpack_public_path__ + "static/media/raccoon.486f985affbee4a03608e49dea1e0eb3.svg";
export { ForwardRef as ReactComponent };